// React Bootstrap components
import { Card, Row, Col } from "react-bootstrap";

//Components
import TabCardHeader from "../../../ui/TabCardHeader";
import OstaliPartnerji from "./OstaliPartnerji";
import PartnerUM from "./PartnerUM";
import RoleGuard from "../../../../auth/RoleGuard";
import AccessDenied from "../../../ui/AccessDenied";

//Auth
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

const PartnerskeOrganizacije = () => {
  return (
    <RoleGuard
      moduleKey={MODULES.PROJEKTI}
      roles={ROLE_GROUPS.ALL}
      fallback={<AccessDenied />}
    >
      <Card className="mb-4">
        {/* Header with title and edit button */}
        <TabCardHeader title="Partnerske organizacije" showEditButton={false} />
        <div className="px-4 pt-4 pb-2">
          <PartnerUM />
          <hr className="form-section-divider" />
          <OstaliPartnerji />
        </div>
      </Card>
    </RoleGuard>
  );
};

export default PartnerskeOrganizacije;
